import { InjectionToken } from '@angular/core';
import { environment } from '@callcenter-env/environment';

/**
 * The workplace (`/call-center`, stage 4) in the routes and the menu — ONE switch, like `NEW_STEP_TWO_READY` of stage 2: `true` — `/call-center` is the new page, the old one lives at
 * `/call-center-old` («Call-center (old)» in «Старые страницы»), the number-of-operator window of the header opens by itself on the old page only; `false` — `/call-center` is the old page, as it was,
 * the window of the header opens on any page at the start, the new page is not reachable. The shell of the stage (`CallStateService`: the subscription to the bus, W1 / W2, the notification; the call band; the window of the link)
 * is behind the switch too — see {@link WORKPLACE_SHELL_ENABLED}: off, `HomeComponent` does what it did before the stage and nothing else runs.
 *
 * On everywhere, production included (the stage is accepted, 20.10).
 */
export const WORKPLACE_READY = true;

/**
 * The same switch for the shell of the pages (`HomeComponent`), as a token like `CALL_LINK_ENABLED`: a spec gives its own value and proves both cases. Off — the shell does not start (no `CallStateService.start()`, so no bus handler
 * of its own, no W1 / W2 / `/rows`, no notification of the shell), the band and the window of the link are not drawn, and the page is fed from the bus by `HomeComponent` as before the stage: production is as it was until the switch is flipped.
 */
export const WORKPLACE_SHELL_ENABLED = new InjectionToken<boolean>('cc.workplace.shellEnabled', { providedIn: 'root', factory: () => WORKPLACE_READY });

/**
 * The simulator of the PBX (the strip at the top of the workplace) is a TEST tool: it sends call events to `/api/asterisk/call-event` as the exchange does. It exists only where the build is not a production one — the token defaults to
 * `!environment.production` and the sender checks it again; a spec gives its own value and proves both cases. The old page has its own (`AsteriskDemoComponent`, unchanged).
 */
export const WORKPLACE_SIMULATOR_ENABLED = new InjectionToken<boolean>('cc.workplace.simulatorEnabled', { providedIn: 'root', factory: () => !environment.production });

export const WORKPLACE_PATH = '/call-center';
export const WORKPLACE_OLD_PATH = '/call-center-old';

/** The path of an address without its query and fragment. */
export function pathOfUrl(url: string | undefined | null): string {
  return (url ?? '').split(/[?#]/)[0];
}

export function isWorkplaceUrl(url: string | undefined | null): boolean {
  return pathOfUrl(url) === WORKPLACE_PATH;
}

export function isOldWorkplaceUrl(url: string | undefined | null): boolean {
  return pathOfUrl(url) === WORKPLACE_OLD_PATH;
}
